import { createActionConst } from '../../../utils/action.utils';

const ACCOUNT_PROJECT_NAMESPACE = 'ACCOUNT_PROJECT';

export const STORE_ACCOUNT_PROJECT = createActionConst(ACCOUNT_PROJECT_NAMESPACE, 'STORE_ACCOUNT_PROJECT');
export const CLEAR_ACCOUNT_PROJECT = createActionConst(ACCOUNT_PROJECT_NAMESPACE, 'CLEAR_ACCOUNT_PROJECT');
